module.exports = __webpack_public_path__ + "static/media/uy.6afe5efa.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/uy.svg
// module id = 1060
// module chunks = 0